import {useCallback} from 'react';

import {getToolIcon, isMCPTool, parseMCPToolName, ToolIconSource} from 'llm/chat-library/tool-details/types';
import {useMCPToolMappingOptional} from 'llm/mcp-client-library/MCPToolMappingContext';

/**
 * React hook for resolving a tool's icon.
 *
 * For MCP tools with a server icon, returns {iconUrl, serverName}.
 * Otherwise returns a BenchlingIconName (e.g. 'plug' for MCP tools, or
 * the tool-specific glyph for built-in tools).
 */
export function useToolIcon(): (toolName: string) => ToolIconSource {
  const mcpMapping = useMCPToolMappingOptional();

  return useCallback(
    (toolName: string): ToolIconSource => {
      if (isMCPTool(toolName)) {
        const {serverName} = parseMCPToolName(toolName);
        const iconUrl = serverName ? (mcpMapping?.getServerIcon(serverName) ?? null) : null;
        if (iconUrl != null) {
          const displayName = mcpMapping?.getServerDisplayName(serverName) ?? serverName;
          return {iconUrl, serverName: displayName};
        }
      }
      return {iconName: getToolIcon(toolName)};
    },
    [mcpMapping]
  );
}
